<template>
  <div class="loginbind" v-show="poplogindg || poplogindialog || poppolice">
    
    <!---s-dg-r2uidtipdg-->
    <van-popup class="p1_dialogr2uidtipdg" :close-on-click-overlay="false" @click="popr2uidtipdg = false" @click-overlay="popr2uidtipdg = false" v-bind:value="popr2uidtipdg" overlay-class="r2uidtipOverlay">
        <!---s-s-ridtipimg-->
        <div class="p1_sliceridtipimg"><img class="p1_diridtipimg" src="@/assets/p1/images/imgridtipimg.png" referrerpolicy="no-referrer" /></div>
    </van-popup>
    <!---s-dg-logindg-->
    <van-popup class="p1_bglogindg p1_dialoglogindg" :close-on-click-overlay="false" v-bind:value="poplogindg">
      <!---s-bt-X-->
      <div class="p1_buttonX"><img class="p1_diX" src="@/assets/p1/images/imgX.png" @click="poplogindg = false"
                                   referrerpolicy="no-referrer"/></div>
      <!--server-->
      <div class="p1_bgserver p1_sserver">
        <!---s-se-serversel-->
        <select v-model="sesseserversel" class="p1_bgsseserversel p1_selectsseserversel"
                @change="handleServerChange">
                <option v-bind:key="''" value="">请选择游戏服</option>
          <option v-for="item in servers" v-bind:key="item.serverId" :value="item.serverId">{{ item.serverName }}</option>
        </select>
      </div>
      <!--R2Uid-->
      <div class="p1_bgR2Uid p1_sR2Uid">
        <!---s-in-inrid-->
        <div class="p1_inputinrid">
          <van-field v-model="ininrid" placeholder="输入R2Uid" @change="handleR2uidChange" @keyup="handleR2uidChange">
          </van-field>
        </div>
        <!---s-bt-帮助-->
        <div class="p1_buttonbangz" @click="popr2uidtipdg = true"><img class="p1_dibangz" src="@/assets/p1/images/imgbangz.png" referrerpolicy="no-referrer" /></div>
      </div>
      <!---s-tx-rolename-->
      <div class="p1_textrolename"><span class="labelWidth">角色名：</span><span class="colorori">{{ roleName }}</span></div>
      <!---s-tx-rolelevel-->
      <div class="p1_textrolelevel"><span class="labelWidth">勇者等级：</span><span class="colorori">{{ roleLevel }}</span></div>
      <!---s-tx-roledesc-->
      <div class="p1_textroledesc">*角色等级更新可能存在延迟</div>
      <!--bindbts-->
      <div class="p1_sbindbts">
        <!---s-bt-rolebtn-->
        <div class="p1_buttonrolebtn"><img class="p1_dirolebtn" @click="findRoleInfo"
                                           src="@/assets/p1/images/imgrolebtn.png" referrerpolicy="no-referrer"/></div>
        <!---s-bt-bind-->
        <div class="p1_buttonbind" v-if="roleName != '' && roleLevel != ''"><img class="p1_dibind" @click="handleBind"
                                                                                 src="@/assets/p1/images/imgbind.png"
                                                                                 referrerpolicy="no-referrer"/></div>
        <!---s-bt-bindgay-->
        <div class="p1_buttonbindgay" v-else><img class="p1_dibindgay" src="@/assets/p1/images/imgbindgay.png"
                                                  referrerpolicy="no-referrer"/></div>
      </div>
    </van-popup>
    <!---s-dg-police-->
    <van-popup class="p1_bgpolice p1_dialogpolice" :close-on-click-overlay="false" @opened="policyOpened"
               position="center" v-bind:value="poppolice">
      <!---s-bt-X-->
      <div class="p1_buttonX_2"><img class="p1_diX_1" src="@/assets/p1/images/imgX.png"
                                     referrerpolicy="no-referrer" @click="poppolice = false; poplogindialog = true"/>
      </div>
      <!---s-tx-policetitle-->
      <div class="p1_textpolicetitle">{{ policyTitle }}</div>
      <!---s-tx-policecontent-->
      <div class="p1_textpolicecontent">
        <policy class="p1_policecontentarea" v-if=" isPolicy "></policy>
        <!-- <textarea class="p1_policecontentarea" readonly v-if="isPolicy" v-pre></textarea> -->

        <user-agreement class="p1_policecontentarea" readonly v-if=" isUserAgree "></user-agreement>
      </div>
    </van-popup>
    <!---s-dg-logindialog-->
    <van-popup class="p1_bglogindialog p1_dialoglogindialog" :close-on-click-overlay=" false "
               v-bind:value=" poplogindialog ">
      <!---s-bt-X-->
      <div class="p1_buttonX_1"><img class="p1_diX_1" src="@/assets/p1/images/imgX.png"
                                     @click=" poplogindialog = false " referrerpolicy="no-referrer"/></div>
      <!--inphone-->
      <div class="p1_bginphone p1_sinphone">
        <!---s-in-inmobile-->
        <div class="p1_inputinmobile">
          <van-field v-model=" ininmobile " type="digit" maxlength="11" placeholder="请输入手机号">
          </van-field>
        </div>
      </div>
      <!--logincode-->
      <div class="p1_bglogincode p1_slogincode flex-row">
        <!---s-in-incode-->
        <div class="p1_inputincode">
          <van-field v-model=" inincode " type="digit" maxlength="6" placeholder="请输入验证码">
          </van-field>
        </div>
        <!---s-tx-获取验证码-->
        <div class="p1_texthuoqyzm" v-if=" !showCountdown " @click=" sendCode ">获取验证码</div>
        <div class="p1_texthuoqyzm" v-else>剩余{{ leftSecond }}秒</div>
      </div>
      <!---s-cb-agree-->
      <van-checkbox class="p1_checkboxscbagree" v-model=" cbscbagree ">
        <template #icon=" props ">
          <img class="p1_discayig" referrerpolicy="no-referrer"
               :src=" props.checked ? cbscbagreeActiveIcon : cbscbagreeInactiveIcon "/>
        </template>
      </van-checkbox>
      <!---s-tx-agreetxt-->
      <div class="p1_textagreetxt">我已阅读并同意<a href="javascript:;" @click=" showUserAgree ">《服务协议》</a>、<a
          href="javascript:;" @click=" showPolicy ">《隐私协议》</a>
        未注册的手机验证后将自动注册。
      </div>
      <!---s-bt-loginbtn-->
      <div class="p1_buttonloginbtn"><img class="p1_diloginbtn" @click="handleLogin"
                                          src="@/assets/p1/images/imgloginbtn.png" referrerpolicy="no-referrer"/></div>
    </van-popup>
    <show-err ref="showErr"></show-err>

  </div>
</template>

<style scoped>
@import "../../assets/p1/css/s1.css";
</style>

<script>

import Vue from 'vue';
import {Popup, Field, Checkbox} from 'vant';
import Policy from '@/components/policy/index.vue';
import UserAgreement from '@/components/useragree/index.vue';
import ShowErr from '@/components/showerr/index.vue';
import {
  sendCode,
  setUserInfo,
  saveMobile,
  saveToken,
  getServerListReturn,
  bind,
  checkBindReq
} from '@/api/common';
import {login} from '@/api/common';
import userInfo from '@/api/states/userinfo'
import { getUserInfo } from '../../api/common';

Vue.use(Popup);
Vue.use(Field);
Vue.use(Checkbox);

export default {
  name: 'LoginBind',
  components: {
    Policy,
    UserAgreement,
    ShowErr
  },
  data() {
    return {
      popr2uidtipdg: false,
      poplogindg: false,
      sesseserversel: '11',
      ininrid: '',
      poppolice: false,
      poplogindialog: false,
      ininmobile: '',
      inincode: '',
      cbscbagree: true,
      cbscbagreeActiveIcon: require('@/assets/p1/images/img-s-ca-yig.png'),
      cbscbagreeInactiveIcon: require('@/assets/p1/images/img-s-cu-weig.png'),
      binded: false,
      showCountdown: false,
      leftSecond: 0,
      servers: [],
      roleName: "",
      roleLevel: "",
      policyTitle: "隐私政策",
      isPolicy: false,
      isUserAgree: false,
      phonePattern: /^11[\d]{9}$|^12[\d]{9}$|^13[\d]{9}$|^14[5,7]{1}\d{8}$|^15[0-3,5-9]{1}\d{8}$|^16[\d]{9}$|^17\d{9}$|^18[\d]{9}$|^19[\d]{9}$/,
      errObj: null,
    };
  },

  methods: {
    async check(showDialog) {
      if (userInfo.isBind) { // 已绑定
        return true
      }
      if (userInfo.isLogin) { // 已登录,未绑定
        // if (showDialog) {
          console.log(111)
          this.showBind()
        // }
        return false
      }
      let res = await getUserInfo()
      if (res.code == 2) {
        if (showDialog) {
          this.showLogin()
        }
        return false
      }
      if (res.code != 0) {
        this.errObj.showErr(res.message)
        return false
      }
      setUserInfo(res)
      if (!userInfo.isBind/* && showDialog*/) {
        this.showBind()
        return false
      }

      return true
    },
    showLogin() {
      this.poplogindialog = true
    },
    handleShowCountdown() {
      if (this.leftSecond > 0) {
        this.showCountdown = true
      } else {
        this.showCountdown = false
        return
      }
      let that = this
      setTimeout(function () {
        that.leftSecond--
        that.handleShowCountdown()
      }, 1000)
    },
    sendCode() {
      if (!this.cbscbagree) {
        this.errObj.showErr('请同意隐私政策和服务协议')
        return
      }
      if (this.ininmobile == "") {
        this.errObj.showErr('请输入手机号')
        return;
      }
      if (!this.phonePattern.test(this.ininmobile)) {
        this.errObj.showErr('请输入正确的手机号')
        return;
      }
      // request
      sendCode(this.ininmobile).then(res => {
        if (res.code !== 0) {
          this.errObj.showErr(res.message)
        } else {
          this.leftSecond = 60
          this.handleShowCountdown()
        }
      }).catch(err => {
        this.errObj.showErr(err)
        console.log(err)
      })
    },
    policyOpened() {
    },
    showPolicy() {

      this.policyTitle = "隐私政策"
      this.poppolice = true
      this.poplogindialog = false

      this.isPolicy = true
      this.isUserAgree = false
    },
    showUserAgree() {
      this.policyTitle = "服务协议"
      this.poppolice = true
      this.poplogindialog = false

      this.isPolicy = false
      this.isUserAgree = true
    },
    handleLogin() {
      if (!this.cbscbagree) {
        this.errObj.showErr('请同意隐私政策和服务协议')
        return
      }
      // console.log(this.ininmobile)
      if (this.ininmobile == "") {
        this.errObj.showErr('请输入手机号')
        return;
      }
      if (!this.phonePattern.test(this.ininmobile)) {
        this.errObj.showErr('请输入正确的手机号')
        return;
      }
      if (this.inincode == "") {
        this.errObj.showErr('请输入验证码')
        return;
      } else if (this.inincode.length < 6) {
        this.errObj.showErr('请输入正确的验证码')
        return;
      }

      // request
      login(this.ininmobile, this.inincode).then(res => {
        if (res.code !== 0) {
          this.errObj.showErr(res.message)
        } else {
          this.logined = true
          this.binded = res.isBind
          this.phone = this.ininmobile
          res.data = res.userId
          setUserInfo(res)
          saveMobile(this.ininmobile)
          saveToken(res.token)
          this.poplogindialog = false

          this.inincode = ""

          this.$emit("login")

          this.showBind()
        }
      }).catch(err => {
        this.errObj.showErr(err)
        console.log(err)
      })
    },
    showBind() {
      console.log("call showBind")
      if (this.poplogindg) {
        return
      }
      if (!userInfo.isBind) {
        this.poplogindg = true
        if (this.sesseserversel == '' || this.ininrid == '') {
          this.sesseserversel = userInfo.lastServerId
          this.ininrid = userInfo.lastGameRid
          this.roleLevel = ''
          this.roleName = ''
        }

        // TODO test
        // this.sesseserversel = '60047'
        // this.ininrid = '2474277'

        getServerListReturn(true).then(res => {
          if (res.code === 0) {
            console.log(res)
            this.servers = res.serverList
          } else {
            this.errObj.showErr(res.message)
          }
        }).catch(err => {
          this.errObj.showErr(err)
        })
      }
    },
    handleServerChange() {
      this.roleName = ""
      this.roleLevel = ""
    },
    handleR2uidChange() {
      this.roleName = ""
      this.roleLevel = ""
    },
    findRoleInfo() {
      if (this.sesseserversel == "") {
        this.errObj.showErr('请选择游戏服务器')
        return
      }
      if (this.ininrid == "" || this.ininrid == "0") {
        this.errObj.showErr('请输入R2Uid')
        return
      }

      checkBindReq(this.ininrid, this.sesseserversel).then(res => {
        if (res.code !== 0) {
          this.errObj.showErr(res.message)
        } else {
          console.log(res)
          this.roleName = res.roleName
          this.roleLevel = res.level + "级勇者"
        }
      }).catch(err => {
        this.errObj.showErr(err)
      })
    },
    handleBind() {
      if (this.roleName == "" || this.roleLevel == "") {
        return
      }

      bind(this.ininrid, this.sesseserversel).then(res => {
        if (res.code !== 0) {
          this.errObj.showErr(res.message)
        } else {
          console.log(res)
          userInfo.isBind = true
          this.$emit("bind", "")
          this.poplogindg = false

          this.errObj.showErr("绑定成功", true)
        }
      })
    }
  },
  mounted() {
    console.log("login bind mounted")
    this.errObj = this.$refs.showErr
  },
  created() {
    console.log("login bind created")
  }
};
</script>
<style>
.r2uidtipOverlay {
  background-color: transparent;
}
</style>
<style scoped>
.loginbind {
  position: fixed;
  height: 100%;
  width: 100%;
  z-index: 1500;
}

.p1_dialoglogindialog {
  margin-left: -0.26rem;
}

.p1_dialoglogindg {
  margin-left: -0.26rem;
}

.p1_dialogpolice {
  margin-left: -0.26rem;
  height: calc(100vh - 3.2rem);
  min-height: 10.320rem;
}

.p1_textagreetxt {
  line-height: 0.34rem;
  width: 4.820rem;
}

.p1_textagreetxt a {
  color: rgba(176, 95, 30, 1);
}

.p1_bgsseserversel {
  position: absolute;
}

.p1_selectsseserversel option {
  color: unset;
  background-color: unset;
}

.p1_textrolename {
  width: 5rem;
  line-height: 0.267rem;
}
.p1_textrolelevel {
  width: 4rem;
}

.p1_policecontent {
  width: 5.4rem;
}

.p1_policecontentarea {
  height: 7.3rem;
  width: 5.4rem;
  background-color: transparent;
  outline: none;
  border: 0;
  line-height: 0.3rem;
  resize: none;
  height: calc(100vh * (7.3 / 13.34));
  min-height: 7.3rem;
}

.p1_buttonX_2 {
  top: max(0.580rem, calc((0.58 / 13.34) * 100vh))
}
.van-popup {
  background-color: transparent;
}
.p1_texthuoqyzm {
  width: 1.6rem;
}
.p1_textroledesc {
  width: 4rem;
  text-align: left;
}
.p1_textrolelevel .labelWidth {
  display: inline-block;
  width: 1.3rem;
  text-align-last: justify;
}
.p1_textrolename .labelWidth {
  display: inline-block;
  width: 1.3rem;
  flex-shrink: 0;
  text-align-last: justify;
}
.colorori {
  color: rgba(176, 95, 30, 1);
}
.p1_sR2Uid {
  display: flex;
}
.p1_textpolicetitle {
  width: 2.76rem;
  left: 2.5rem;
  text-align: center;
}
</style>